import { render, staticRenderFns } from "./WarehousePurchaseOrderTable.vue?vue&type=template&id=4daa48bb"
import script from "./WarehousePurchaseOrderTable.vue?vue&type=script&lang=js"
export * from "./WarehousePurchaseOrderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports